import AxiosJob from "@/services/api/job/axios_job";

export default {
  getNextStatusesByCurrentStatus: (id, params) => {
    return AxiosJob.get(`next-status/by-current/${id}`, { params });
  },

  createNextStatus: (data) => {
    return AxiosJob.post('next-status', data);
  },

  deleteNextStatus: (params) => {
    return AxiosJob.delete('next-status', { data: params })
  },

  getByCurrentPoolStatus: (jobPoolStatusId) => {
    return AxiosJob.get(`next-status/by-current/${jobPoolStatusId}`)
  },

  getByNextPoolStatus: (jobPoolStatusId) => {
    return AxiosJob.get(`next-status/by-next/${jobPoolStatusId}`)
  },
}
